import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject, filter, take } from 'rxjs';
import { selectConfig } from '../../../infrastructure/store/selectors/config.selector';
import { environment } from '../../../../environments/environment';

export const FILL_SUBMIT_MESSAGE = 'mng-fill-form:submit';
export const FILL_SAVE_MESSAGE = 'mng-fill-form:save';

@Component({
  selector: 'app-fill',
  templateUrl: './fill.component.html',
  styleUrls: ['./fill.component.scss']
})
export class FillComponent implements OnInit { 
  unsubscribe$ = new Subject();
  
  formOptions = {};
  urlBackend: string = "";
  errorMessage = null;

  constructor(private store: Store, private route: ActivatedRoute) { }
   
  ngOnInit(): void {
    // Vertical scroll enabled
    (document.querySelector('app-root') as HTMLElement).style.overflowY = 'auto';
    this.store.select(selectConfig).pipe(
      filter(x => x.data['FORM_API']),
			take(1)   
    ).subscribe({
      next: (v) => {          
        if(v) {
          this.errorMessage = null;
          this.urlBackend = v.data['FORM_API'];
          this.formOptions = {
            // El web component lee los query params de window.parent; dentro de un iframe
            // (p. ej. la landing) no ve los de /fill, así que se pasan también como propiedades
            ...this.route.snapshot.queryParams,
            urlBackend: this.urlBackend,
            urlBackendAccessControl: environment.accessControlAPI,
            //name: 'InjectedName'
          }
        }
      },
      error: (e) => {         
        console.log('ERROR->', <any>e);
        this.errorMessage = e;
      }
    });
  }

  onFormSubmit(event) {
    console.log('onFormSubmit:', event);
    this.notifyParent(FILL_SUBMIT_MESSAGE, event);
  }

  onFormSave(event) {
    console.log('onFormSave:', event);
    this.notifyParent(FILL_SAVE_MESSAGE, event);
  }

  // Si /fill está embebido en un iframe del mismo origen (p. ej. la landing), avisa al padre.
  // El web component emite un CustomEvent (no clonable por postMessage): se envía su detail
  private notifyParent(type: string, event: CustomEvent | any): void {
    if (window.parent === window) return;
    const data = event instanceof CustomEvent ? event.detail : event;
    window.parent.postMessage({ type, data }, window.location.origin);
  }

}
